module.exports = __webpack_public_path__ + "static/blue-sun-a78bf10ba2c7921edced276822db9c84.jpg";